import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  const closeMenu = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const PHONE_DISPLAY = "+91 99592 71353";
  const PHONE_TEL = "+919959271353";

  return (
    <div className="w-full m-0 p-0 bg-white">
      <footer className="w-full bg-[#018b81] text-white py-12 px-6 md:px-12 lg:px-16 xl:px-24 rounded-t-3xl">
        {/* Wider container for TVs while keeping readable line-length on desktops */}
        <div className="mx-auto w-full max-w-screen-2xl">
          {/* Unified grid: 1→2→4 columns */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 items-start">
            {/* Contact Us */}
            <section className="min-w-0">
              <h4 className="text-xl font-bold tracking-tight leading-none mb-5">
                Contact Us
              </h4>

              <a href={`tel:${PHONE_TEL}`} className="block">
                <p className="flex items-center gap-2 mb-2 hover:opacity-90">
                  <FaPhoneAlt aria-hidden="true" /> {PHONE_DISPLAY}
                </p>
              </a>

              <a href="mailto:info@rankridgecollege.com" className="block">
                <p className="flex items-center gap-2 mb-2 hover:opacity-90">
                  <FaEnvelope aria-hidden="true" /> info@rankridgecollege.com
                </p>
              </a>

              <p className="flex items-center gap-2">
                <FaMapMarkerAlt aria-hidden="true" /> Hyderabad, Telangana
              </p>

              {/* Social bar */}
              <div className="w-full bg-white/95 py-4 px-4 mt-5 rounded-lg">
                <div className="flex flex-wrap items-center gap-5">
                  <a
                    href="https://www.youtube.com/@rankridgejuniorcollege"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                    title="YouTube"
                  >
                    <FaYoutube className="text-[#FF0000] text-2xl hover:scale-110 transition" />
                  </a>
                  <a
                    href="https://www.instagram.com/rankridgejuniorcollege/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    title="Instagram"
                  >
                    <FaInstagram className="text-[#C13584] text-2xl hover:scale-110 transition" />
                  </a>
                  <a
                    href="https://x.com/RankRidge/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="X (Twitter)"
                    title="X (Twitter)"
                  >
                    <FaXTwitter className="text-black text-2xl hover:scale-110 transition" />
                  </a>
                  <a
                    href="https://www.facebook.com/Rankridge/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    title="Facebook"
                  >
                    <FaFacebookF className="text-[#1877F2] text-2xl hover:scale-110 transition" />
                  </a>
                  <a
                    href="https://in.linkedin.com/company/rankridge-educational-institutions-pvt-ltd/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                    title="LinkedIn"
                  >
                    <FaLinkedinIn className="text-[#0A66C2] text-2xl hover:scale-110 transition" />
                  </a>
                </div>
              </div>
            </section>

            {/* Explore */}
            <section className="min-w-0">
              <h4 className="text-xl font-bold tracking-tight leading-none mb-5">
                Explore
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" onClick={closeMenu} className="hover:text-green-300">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about-us/" onClick={closeMenu} className="hover:text-green-300">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us/" onClick={closeMenu} className="hover:text-green-300">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/track-records" onClick={closeMenu} className="hover:text-green-300">
                    Track Records
                  </Link>
                </li>
                <li>
                  {/* matches your current route spelling */}
                  <Link to="/gellary" onClick={closeMenu} className="hover:text-green-300">
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link to="/signup/" onClick={closeMenu} className="hover:text-green-300">
                    Sign Up
                  </Link>
                </li>

                 <li>
                    <Link to="/terms-and-conditions/" onClick={closeMenu} className="hover:text-green-300">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy/" onClick={closeMenu} className="hover:text-green-300">
                      Privacy Policy
                    </Link>
                  </li>
              </ul>
            </section>

            {/* Programs */}
            <section className="min-w-0">
              <h4 className="text-xl font-bold tracking-tight leading-none mb-5">
                Programs
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/mpc-with-iit-jee/" onClick={closeMenu} className="hover:text-green-300">
                    MPC with IIT-JEE
                  </Link>
                </li>
                <li>
                  <Link
                    to="/engineering-medical-entrance-coaching-in-hyderabad/"
                    onClick={closeMenu}
                    className="hover:text-green-300"
                  >
                    Engg & Medical Entrance (Long-Term)
                  </Link>
                </li>
                <li>
                  <Link to="/eamcet-coaching-in-hyderabad/" onClick={closeMenu} className="hover:text-green-300">
                    EAMCET Coaching
                  </Link>
                </li>
                <li>
                  <Link to="/best-junior-college-in-hyderabad/" onClick={closeMenu} className="hover:text-green-300">
                    Intermediate (Junior College)
                  </Link>
                </li>
                <li>
                  <Link
                    to="/best-neet-coaching-center-in-hyderbad/"
                    onClick={closeMenu}
                    className="hover:text-green-300"
                  >
                    BiPC with NEET
                  </Link>
                </li>
                <li>
                  <Link
                    to="/iit-jee-neet-eamcet-bitsat-short-term-coaching-hyderabad/"
                    onClick={closeMenu}
                    className="hover:text-green-300"
                  >
                    Short-Term / Crash Courses
                  </Link>
                </li>
                <li>
                  <Link to="/neet-coaching-in-hyderabad/" onClick={closeMenu} className="hover:text-green-300">
                    NEET Long-Term
                  </Link>
                </li>
              </ul>
            </section>

            {/* Find Us */}
            <section className="min-w-0">
              <h4 className="text-xl font-bold tracking-tight leading-none mb-5">
                Find Us
              </h4>
              <div className="overflow-hidden rounded-lg shadow-lg h-64">
                <iframe
                  title="Rankridge College Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.3643546417666!2d78.39237617493723!3d17.49011218341474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9142171bf8fd%3A0x25cda1199abf1471!2sRANKRIDGE%20-%20Best%20INTER%20College%20%26%20IITJEE%20%7C%20NEET%20%7C%20EAMCET%20Coaching.%20Top%20Junior%20College%20for%20MPC%20%7C%20BIPC%20in%20Hyderabad%20Telangana!5e0!3m2!1sen!2sin!4v1752565372468!5m2!1sen!2sin"
                  className="w-full h-full border-0"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>

              {/* Legal under Find Us to keep 4 clean columns */}
              {/* <div className="mt-6">
                <h5 className="text-lg font-semibold mb-3">Legal</h5>
                <ul className="space-y-2">
                  <li>
                    <Link to="/terms-and-conditions/" onClick={closeMenu} className="hover:text-green-300">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy/" onClick={closeMenu} className="hover:text-green-300">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div> */}
            </section>
          </div>

          {/* Bottom bar */}
          <div className="text-center mt-10 border-t pt-6 text-sm text-black">
            All rights reserved – {new Date().getFullYear()} <br />
            Rankridge Educational Institutions Pvt. Ltd.
          </div>
        </div>
      </footer>
    </div>
  );
}
